/* eslint-disable max-len, prettier/prettier */
/* AUTOMATICALLY GENERATED FILE (generateSvgIndexFile.mjs), DO NOT EDIT DIRECTLY */
import React from 'react';

import { ReactComponent as Svg2021OpKertovakuvitus28818 } from './2021_OP_kertovakuvitus_288-18.svg';
import { ReactComponent as SvgOpKertovakuvitus28813 } from './OP_kertovakuvitus_288-13.svg';
import { ReactComponent as SvgOpKulut } from './OP_kulut.svg';
import { ReactComponent as SvgOpRecap } from './OP_recap.svg';
import { ReactComponent as SvgOpRiskit } from './OP_riskit.svg';
import { ReactComponent as SvgOpSymbolikuvitus128002 } from './OP_symbolikuvitus_128_002.svg';
import { ReactComponent as SvgOpSymbolikuvitus128003 } from './OP_symbolikuvitus_128_003.svg';
import { ReactComponent as SvgOpSymbolikuvitus128006 } from './OP_symbolikuvitus_128_006.svg';
import { ReactComponent as SvgOpSymbolikuvitus128007 } from './OP_symbolikuvitus_128_007.svg';
import { ReactComponent as SvgOpSymbolikuvitus128008 } from './OP_symbolikuvitus_128_008.svg';
import { ReactComponent as SvgOpSymbolikuvitus128009 } from './OP_symbolikuvitus_128_009.svg';
import { ReactComponent as SvgOpSymbolikuvitus128011 } from './OP_symbolikuvitus_128_011.svg';
import { ReactComponent as SvgOpSymbolikuvitus128013 } from './OP_symbolikuvitus_128_013.svg';
import { ReactComponent as SvgOpSymbolikuvitus128021 } from './OP_symbolikuvitus_128_021.svg';
import { ReactComponent as SvgOpSymbolikuvitus128022 } from './OP_symbolikuvitus_128_022.svg';
import { ReactComponent as SvgOpSymbolikuvitus128026 } from './OP_symbolikuvitus_128_026.svg';
import { ReactComponent as SvgOpSymbolikuvitus128028 } from './OP_symbolikuvitus_128_028.svg';
import { ReactComponent as SvgOpSymbolikuvitus128029 } from './OP_symbolikuvitus_128_029.svg';
import { ReactComponent as SvgOpSymbolikuvitus128030 } from './OP_symbolikuvitus_128_030.svg';
import { ReactComponent as SvgOpSymbolikuvitus128034 } from './OP_symbolikuvitus_128_034.svg';
import { ReactComponent as SvgOpSymbolikuvitus128035 } from './OP_symbolikuvitus_128_035.svg';
import { ReactComponent as SvgOpSymbolikuvitus128037 } from './OP_symbolikuvitus_128_037.svg';
import { ReactComponent as SvgOpSymbolikuvitus128044 } from './OP_symbolikuvitus_128_044.svg';
import { ReactComponent as SvgOpSymbolikuvitus128046 } from './OP_symbolikuvitus_128_046.svg';
import { ReactComponent as SvgOpSymbolikuvitus128047 } from './OP_symbolikuvitus_128_047.svg';
import { ReactComponent as SvgOpSymbolikuvitus128050 } from './OP_symbolikuvitus_128_050.svg';
import { ReactComponent as SvgOpSymbolikuvitus128052 } from './OP_symbolikuvitus_128_052.svg';
import { ReactComponent as SvgOpSymbolikuvitus128053 } from './OP_symbolikuvitus_128_053.svg';
import { ReactComponent as SvgOpSymbolikuvitus128054 } from './OP_symbolikuvitus_128_054.svg';
import { ReactComponent as SvgOpSymbolikuvitus128057 } from './OP_symbolikuvitus_128_057.svg';
import { ReactComponent as SvgOpSymbolikuvitus128058 } from './OP_symbolikuvitus_128_058.svg';
import { ReactComponent as SvgOpSymbolikuvitus128059 } from './OP_symbolikuvitus_128_059.svg';
import { ReactComponent as SvgOpSymbolikuvitus128060 } from './OP_symbolikuvitus_128_060.svg';
import { ReactComponent as SvgOpSymbolikuvitus96001 } from './OP_symbolikuvitus_96_001.svg';
import { ReactComponent as SvgOpSymbolikuvitus96003 } from './OP_symbolikuvitus_96_003.svg';
import { ReactComponent as SvgOpSymbolikuvitus96006 } from './OP_symbolikuvitus_96_006.svg';
import { ReactComponent as SvgOpSymbolikuvitus96008 } from './OP_symbolikuvitus_96_008.svg';
import { ReactComponent as SvgOpSymbolikuvitus96013 } from './OP_symbolikuvitus_96_013.svg';
import { ReactComponent as SvgOpSymbolikuvitus96027 } from './OP_symbolikuvitus_96_027.svg';
import { ReactComponent as SvgOpSymbolikuvitus96030 } from './OP_symbolikuvitus_96_030.svg';
import { ReactComponent as SvgOpSymbolikuvitus96034 } from './OP_symbolikuvitus_96_034.svg';
import { ReactComponent as SvgOpSymbolikuvitus96069 } from './OP_symbolikuvitus_96_069.svg';
import { ReactComponent as SvgOpSymbolikuvitus96072 } from './OP_symbolikuvitus_96_072.svg';
import { ReactComponent as SvgOpSymbolikuvitus96075 } from './OP_symbolikuvitus_96_075.svg';
import { ReactComponent as SvgOpSymbolikuvitus96079 } from './OP_symbolikuvitus_96_079.svg';
import { ReactComponent as SvgOpSymbolikuvitus96095 } from './OP_symbolikuvitus_96_095.svg';
import { ReactComponent as SvgOpSymbolikuvitus96097 } from './OP_symbolikuvitus_96_097.svg';
import { ReactComponent as SvgOpSymbolikuvitus96120 } from './OP_symbolikuvitus_96_120.svg';
import { ReactComponent as SvgOpSymbolikuvitus96121 } from './OP_symbolikuvitus_96_121.svg';
import { ReactComponent as SvgOpSymbolikuvitus96129 } from './OP_symbolikuvitus_96_129.svg';
import { ReactComponent as SvgOpSymbolikuvitus96132 } from './OP_symbolikuvitus_96_132.svg';
import { ReactComponent as SvgOpSymbolikuvitus96136 } from './OP_symbolikuvitus_96_136.svg';
import { ReactComponent as SvgOpSymbolikuvitus96139 } from './OP_symbolikuvitus_96_139.svg';
import { ReactComponent as SvgOpSymbolikuvitus96142 } from './OP_symbolikuvitus_96_142.svg';
import { ReactComponent as SvgArrowHorizontalFull } from './arrow-horizontal-full.svg';
import { ReactComponent as SvgArrowHorizontal } from './arrow-horizontal.svg';
import { ReactComponent as SvgArrowVerticalFull } from './arrow-vertical-full.svg';
import { ReactComponent as SvgArrowVertical } from './arrow-vertical.svg';
import { ReactComponent as SvgCertificateEn } from './certificate_en.svg';
import { ReactComponent as SvgCertificateFi } from './certificate_fi.svg';
import { ReactComponent as SvgCertificateSv } from './certificate_sv.svg';
import { ReactComponent as SvgCircle } from './circle.svg';
import { ReactComponent as SvgDiamond } from './diamond.svg';
import { ReactComponent as SvgGreenCircle } from './green-circle.svg';
import { ReactComponent as SvgLine } from './line.svg';
import { ReactComponent as SvgMain } from './main.svg';
import { ReactComponent as SvgMountain } from './mountain.svg';
import { ReactComponent as SvgNoSearchResults96 } from './no_search_results_96.svg';
import { ReactComponent as SvgPaint } from './paint.svg';
import { ReactComponent as SvgRectangleTilted } from './rectangle-tilted.svg';
import { ReactComponent as SvgRectangle } from './rectangle.svg';
import { ReactComponent as SvgRocket } from './rocket.svg';
import { ReactComponent as SvgSun } from './sun.svg';
import { ReactComponent as SvgSymbolBankingWithdrawal96 } from './symbol_banking_withdrawal_96.svg';
import { ReactComponent as SvgSymbolDeveloperCorporatePaymentApi128 } from './symbol_developer_corporate_payment_API_128.svg';
import { ReactComponent as SvgSymbolDeveloperCorporateRefundApi128 } from './symbol_developer_corporate_refund_API_128.svg';
import { ReactComponent as SvgSymbolHealthBandAid96 } from './symbol_health_band_aid_96.svg';
import { ReactComponent as SvgSymbolInsuranceLoss96 } from './symbol_insurance_loss_96.svg';
import { ReactComponent as SvgSymbolMiscBook96 } from './symbol_misc_book_96.svg';
import { ReactComponent as SvgSymbolMiscGoals128 } from './symbol_misc_goals_128.svg';
import { ReactComponent as SvgSymbolMiscNotification0196 } from './symbol_misc_notification_01_96.svg';
import { ReactComponent as SvgSymbolMiscNotification0296 } from './symbol_misc_notification_02_96.svg';
import { ReactComponent as SvgSymbolMiscPriorities128 } from './symbol_misc_priorities_128.svg';
import { ReactComponent as SvgSymbolMiscSun96 } from './symbol_misc_sun_96.svg';
import { ReactComponent as SvgSymbolOwnercustomerBonusAccount96 } from './symbol_ownercustomer_Bonus_account_96.svg';
import { ReactComponent as SvgSymbolOwnercustomerOpBonuses96 } from './symbol_ownercustomer_OP_bonuses_96.svg';
import { ReactComponent as SvgTriangleGray } from './triangle-gray.svg';
import { ReactComponent as SvgTriangle } from './triangle.svg';

export { Svg2021OpKertovakuvitus28818 };
export { SvgOpKertovakuvitus28813 };
export { SvgOpKulut };
export { SvgOpRecap };
export { SvgOpRiskit };
export { SvgOpSymbolikuvitus128002 };
export { SvgOpSymbolikuvitus128003 };
export { SvgOpSymbolikuvitus128006 };
export { SvgOpSymbolikuvitus128007 };
export { SvgOpSymbolikuvitus128008 };
export { SvgOpSymbolikuvitus128009 };
export { SvgOpSymbolikuvitus128011 };
export { SvgOpSymbolikuvitus128013 };
export { SvgOpSymbolikuvitus128021 };
export { SvgOpSymbolikuvitus128022 };
export { SvgOpSymbolikuvitus128026 };
export { SvgOpSymbolikuvitus128028 };
export { SvgOpSymbolikuvitus128029 };
export { SvgOpSymbolikuvitus128030 };
export { SvgOpSymbolikuvitus128034 };
export { SvgOpSymbolikuvitus128035 };
export { SvgOpSymbolikuvitus128037 };
export { SvgOpSymbolikuvitus128044 };
export { SvgOpSymbolikuvitus128046 };
export { SvgOpSymbolikuvitus128047 };
export { SvgOpSymbolikuvitus128050 };
export { SvgOpSymbolikuvitus128052 };
export { SvgOpSymbolikuvitus128053 };
export { SvgOpSymbolikuvitus128054 };
export { SvgOpSymbolikuvitus128057 };
export { SvgOpSymbolikuvitus128058 };
export { SvgOpSymbolikuvitus128059 };
export { SvgOpSymbolikuvitus128060 };
export { SvgOpSymbolikuvitus96001 };
export { SvgOpSymbolikuvitus96003 };
export { SvgOpSymbolikuvitus96006 };
export { SvgOpSymbolikuvitus96008 };
export { SvgOpSymbolikuvitus96013 };
export { SvgOpSymbolikuvitus96027 };
export { SvgOpSymbolikuvitus96030 };
export { SvgOpSymbolikuvitus96034 };
export { SvgOpSymbolikuvitus96069 };
export { SvgOpSymbolikuvitus96072 };
export { SvgOpSymbolikuvitus96075 };
export { SvgOpSymbolikuvitus96079 };
export { SvgOpSymbolikuvitus96095 };
export { SvgOpSymbolikuvitus96097 };
export { SvgOpSymbolikuvitus96120 };
export { SvgOpSymbolikuvitus96121 };
export { SvgOpSymbolikuvitus96129 };
export { SvgOpSymbolikuvitus96132 };
export { SvgOpSymbolikuvitus96136 };
export { SvgOpSymbolikuvitus96139 };
export { SvgOpSymbolikuvitus96142 };
export { SvgArrowHorizontalFull };
export { SvgArrowHorizontal };
export { SvgArrowVerticalFull };
export { SvgArrowVertical };
export { SvgCertificateEn };
export { SvgCertificateFi };
export { SvgCertificateSv };
export { SvgCircle };
export { SvgDiamond };
export { SvgGreenCircle };
export { SvgLine };
export { SvgMain };
export { SvgMountain };
export { SvgNoSearchResults96 };
export { SvgPaint };
export { SvgRectangleTilted };
export { SvgRectangle };
export { SvgRocket };
export { SvgSun };
export { SvgSymbolBankingWithdrawal96 };
export { SvgSymbolDeveloperCorporatePaymentApi128 };
export { SvgSymbolDeveloperCorporateRefundApi128 };
export { SvgSymbolHealthBandAid96 };
export { SvgSymbolInsuranceLoss96 };
export { SvgSymbolMiscBook96 };
export { SvgSymbolMiscGoals128 };
export { SvgSymbolMiscNotification0196 };
export { SvgSymbolMiscNotification0296 };
export { SvgSymbolMiscPriorities128 };
export { SvgSymbolMiscSun96 };
export { SvgSymbolOwnercustomerBonusAccount96 };
export { SvgSymbolOwnercustomerOpBonuses96 };
export { SvgTriangleGray };
export { SvgTriangle };

export const svgComponents: { [key: string]: React.FC<React.SVGProps<SVGSVGElement>> } = {
  '2021_OP_kertovakuvitus_288-18.svg': Svg2021OpKertovakuvitus28818,
  'OP_kertovakuvitus_288-13.svg': SvgOpKertovakuvitus28813,
  'OP_kulut.svg': SvgOpKulut,
  'OP_recap.svg': SvgOpRecap,
  'OP_riskit.svg': SvgOpRiskit,
  'OP_symbolikuvitus_128_002.svg': SvgOpSymbolikuvitus128002,
  'OP_symbolikuvitus_128_003.svg': SvgOpSymbolikuvitus128003,
  'OP_symbolikuvitus_128_006.svg': SvgOpSymbolikuvitus128006,
  'OP_symbolikuvitus_128_007.svg': SvgOpSymbolikuvitus128007,
  'OP_symbolikuvitus_128_008.svg': SvgOpSymbolikuvitus128008,
  'OP_symbolikuvitus_128_009.svg': SvgOpSymbolikuvitus128009,
  'OP_symbolikuvitus_128_011.svg': SvgOpSymbolikuvitus128011,
  'OP_symbolikuvitus_128_013.svg': SvgOpSymbolikuvitus128013,
  'OP_symbolikuvitus_128_021.svg': SvgOpSymbolikuvitus128021,
  'OP_symbolikuvitus_128_022.svg': SvgOpSymbolikuvitus128022,
  'OP_symbolikuvitus_128_026.svg': SvgOpSymbolikuvitus128026,
  'OP_symbolikuvitus_128_028.svg': SvgOpSymbolikuvitus128028,
  'OP_symbolikuvitus_128_029.svg': SvgOpSymbolikuvitus128029,
  'OP_symbolikuvitus_128_030.svg': SvgOpSymbolikuvitus128030,
  'OP_symbolikuvitus_128_034.svg': SvgOpSymbolikuvitus128034,
  'OP_symbolikuvitus_128_035.svg': SvgOpSymbolikuvitus128035,
  'OP_symbolikuvitus_128_037.svg': SvgOpSymbolikuvitus128037,
  'OP_symbolikuvitus_128_044.svg': SvgOpSymbolikuvitus128044,
  'OP_symbolikuvitus_128_046.svg': SvgOpSymbolikuvitus128046,
  'OP_symbolikuvitus_128_047.svg': SvgOpSymbolikuvitus128047,
  'OP_symbolikuvitus_128_050.svg': SvgOpSymbolikuvitus128050,
  'OP_symbolikuvitus_128_052.svg': SvgOpSymbolikuvitus128052,
  'OP_symbolikuvitus_128_053.svg': SvgOpSymbolikuvitus128053,
  'OP_symbolikuvitus_128_054.svg': SvgOpSymbolikuvitus128054,
  'OP_symbolikuvitus_128_057.svg': SvgOpSymbolikuvitus128057,
  'OP_symbolikuvitus_128_058.svg': SvgOpSymbolikuvitus128058,
  'OP_symbolikuvitus_128_059.svg': SvgOpSymbolikuvitus128059,
  'OP_symbolikuvitus_128_060.svg': SvgOpSymbolikuvitus128060,
  'OP_symbolikuvitus_96_001.svg': SvgOpSymbolikuvitus96001,
  'OP_symbolikuvitus_96_003.svg': SvgOpSymbolikuvitus96003,
  'OP_symbolikuvitus_96_006.svg': SvgOpSymbolikuvitus96006,
  'OP_symbolikuvitus_96_008.svg': SvgOpSymbolikuvitus96008,
  'OP_symbolikuvitus_96_013.svg': SvgOpSymbolikuvitus96013,
  'OP_symbolikuvitus_96_027.svg': SvgOpSymbolikuvitus96027,
  'OP_symbolikuvitus_96_030.svg': SvgOpSymbolikuvitus96030,
  'OP_symbolikuvitus_96_034.svg': SvgOpSymbolikuvitus96034,
  'OP_symbolikuvitus_96_069.svg': SvgOpSymbolikuvitus96069,
  'OP_symbolikuvitus_96_072.svg': SvgOpSymbolikuvitus96072,
  'OP_symbolikuvitus_96_075.svg': SvgOpSymbolikuvitus96075,
  'OP_symbolikuvitus_96_079.svg': SvgOpSymbolikuvitus96079,
  'OP_symbolikuvitus_96_095.svg': SvgOpSymbolikuvitus96095,
  'OP_symbolikuvitus_96_097.svg': SvgOpSymbolikuvitus96097,
  'OP_symbolikuvitus_96_120.svg': SvgOpSymbolikuvitus96120,
  'OP_symbolikuvitus_96_121.svg': SvgOpSymbolikuvitus96121,
  'OP_symbolikuvitus_96_129.svg': SvgOpSymbolikuvitus96129,
  'OP_symbolikuvitus_96_132.svg': SvgOpSymbolikuvitus96132,
  'OP_symbolikuvitus_96_136.svg': SvgOpSymbolikuvitus96136,
  'OP_symbolikuvitus_96_139.svg': SvgOpSymbolikuvitus96139,
  'OP_symbolikuvitus_96_142.svg': SvgOpSymbolikuvitus96142,
  'arrow-horizontal-full.svg': SvgArrowHorizontalFull,
  'arrow-horizontal.svg': SvgArrowHorizontal,
  'arrow-vertical-full.svg': SvgArrowVerticalFull,
  'arrow-vertical.svg': SvgArrowVertical,
  'certificate_en.svg': SvgCertificateEn,
  'certificate_fi.svg': SvgCertificateFi,
  'certificate_sv.svg': SvgCertificateSv,
  'circle.svg': SvgCircle,
  'diamond.svg': SvgDiamond,
  'green-circle.svg': SvgGreenCircle,
  'line.svg': SvgLine,
  'main.svg': SvgMain,
  'mountain.svg': SvgMountain,
  'no_search_results_96.svg': SvgNoSearchResults96,
  'paint.svg': SvgPaint,
  'rectangle-tilted.svg': SvgRectangleTilted,
  'rectangle.svg': SvgRectangle,
  'rocket.svg': SvgRocket,
  'sun.svg': SvgSun,
  'symbol_banking_withdrawal_96.svg': SvgSymbolBankingWithdrawal96,
  'symbol_developer_corporate_payment_API_128.svg': SvgSymbolDeveloperCorporatePaymentApi128,
  'symbol_developer_corporate_refund_API_128.svg': SvgSymbolDeveloperCorporateRefundApi128,
  'symbol_health_band_aid_96.svg': SvgSymbolHealthBandAid96,
  'symbol_insurance_loss_96.svg': SvgSymbolInsuranceLoss96,
  'symbol_misc_book_96.svg': SvgSymbolMiscBook96,
  'symbol_misc_goals_128.svg': SvgSymbolMiscGoals128,
  'symbol_misc_notification_01_96.svg': SvgSymbolMiscNotification0196,
  'symbol_misc_notification_02_96.svg': SvgSymbolMiscNotification0296,
  'symbol_misc_priorities_128.svg': SvgSymbolMiscPriorities128,
  'symbol_misc_sun_96.svg': SvgSymbolMiscSun96,
  'symbol_ownercustomer_Bonus_account_96.svg': SvgSymbolOwnercustomerBonusAccount96,
  'symbol_ownercustomer_OP_bonuses_96.svg': SvgSymbolOwnercustomerOpBonuses96,
  'triangle-gray.svg': SvgTriangleGray,
  'triangle.svg': SvgTriangle,
};
